export default __webpack_public_path__ + "static/media/zyda-image.31e53f80.png";